module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.32bb0e26.woff";